import { makeService } from './api';

const service = makeService('expenses');

export default service;